<template>
    <div class="">
		<div class="page-icon">
			<font-awesome-icon :icon="['fas','coffee']" />
		</div>
		<div class="actions">
			<div class="action action--wide">
				<a class="action-button action-button--break" href="#" @click.prevent="endBreak">
					{{ $t('labels.end_break') }}
				</a>
			</div>
		</div>

        <cancel-button></cancel-button>
    </div>
</template>

<script>
	import CancelButton from "../components/app/CancelButton";
	import moment from 'moment';
	import { writeTrackLog } from "../utils/tracking";

	export default {
		name: 'break',

        components: {CancelButton},

        methods: {
            endBreak() {
				if (this.$store.state.enableTracking) writeTrackLog('End break: ' + JSON.stringify(this.currentBreak));

				this.$store.dispatch('updateActivity', {
                    id: this.currentBreak.id,
                    end: new moment().toISOString()
                });

				if (this.currentActivity !== null && this.currentActivity !== undefined) {
                    this.$store.dispatch('updateActivity', {
                        id: this.currentActivity.id,
                        on_hold: false
                    })
				}

				this.$store.commit('setChecked')
			}
		},

        computed: {
            currentBreak() {
                return this.$store.getters.currentBreakForEmployee
            },

			currentActivity () {
                return this.$store.getters.currentActivityForEmployee
			}
        },

		mounted () {
			if (this.$store.state.enableTracking) writeTrackLog("VIEW: Break");
		}
    }
</script>
